import { permissionsSelectors } from 'ducks/permissions'
import { BulkOptionType } from 'elements/hardwareSelectorV2/types'
import { useSelector } from 'react-redux'
import OrderLineItem from '../OrderLineItem'
import { AddToCartButton } from './AddToCartButton'
import BulkPriceButton from './BulkPriceButton'
import QuantityButton from './QuantityButton'

type ActionButtonProps = {
  cartItem: OrderLineItem | null
  showConnectDistributorLink?: boolean
  bulkQuantity: number
  setBulkQuantity: (quantity: number) => void
  handleAddToCart: () => void
  handleQuantityChange: (quantity: number) => void
  bulkOptions: BulkOptionType[]
  selectedBulkOption: BulkOptionType | null
  setBulkOption: (bulkOption: BulkOptionType | null) => void
  isDisabled?: boolean
}

const ActionButton = ({
  cartItem,
  showConnectDistributorLink = false,
  bulkQuantity,
  setBulkQuantity,
  handleAddToCart,
  handleQuantityChange,
  bulkOptions,
  selectedBulkOption,
  setBulkOption,
  isDisabled,
}: ActionButtonProps) => {
  const { allowEdit: allowEditShop } = useSelector((state) =>
    permissionsSelectors.getPermissionByKey(state, 'shop_hardware_access')
  )
  if (!!bulkOptions?.length && !showConnectDistributorLink) {
    return (
      <BulkPriceButton
        bulkOptions={bulkOptions}
        quantity={bulkQuantity}
        setQuantity={setBulkQuantity}
        handleAddToCart={handleAddToCart}
        showConnectDistributorLink={showConnectDistributorLink}
        setBulkOption={setBulkOption}
        selectedBulkOption={selectedBulkOption}
        disabled={isDisabled || !allowEditShop}
      />
    )
  }
  if (!!cartItem && !showConnectDistributorLink) {
    return (
      <QuantityButton
        onChangeQuantity={handleQuantityChange}
        initialValue={cartItem?.quantity}
        disabled={isDisabled || !allowEditShop}
      />
    )
  }

  return (
    <AddToCartButton
      onClick={(event) => {
        event.stopPropagation()
        handleAddToCart()
      }}
      disabled={showConnectDistributorLink || isDisabled || !allowEditShop}
    />
  )
}

export default ActionButton
